import { MutationTree, Mutation } from 'vuex';
import { IState, IResult } from './state';
import { ActionPayload } from './actions';

interface IDateRange {
    start: Date
    end: Date
}

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}

const setResultMutation: MutationHandler<IResult> = (state, { payload }) => {
	state.result = payload
}

const addResultMutation: MutationHandler<IResult> = (state, { payload }) => {
	state.result.amount = payload.amount
	state.result.hits = state.result.hits.concat(payload.hits)
}

const updateFilterCountMutation: MutationHandler<IResult> = (state, { payload }) => {
	payload.filterAmount.forEach((filter: any) => {
		state.filters.find(stateFilter => {
			if(filter.name === stateFilter.name) {
				Object.assign(stateFilter, {amount: filter.amount})
				return true
			}
			return false
		})
	})
}

const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
	state.query = payload
}

const setFilterModalMutation: MutationHandler<string> = (state, { payload }) => {
	state.showFilter = !state.showFilter
}

const removeFilterModalMutation: MutationHandler<string> = (state, { payload }) => {
	state.showFilter = false
}

const setRangeFilterModalMutation: MutationHandler<IDateRange> = (state, { payload }) => {
	if(!payload || !payload.start || !payload.end) {
		state.date = { start: undefined, end: undefined }
		return
	}
	state.date = { start: payload.start, end: payload.end }
}

const setFilterMutation: MutationHandler<string> = (state, { payload }) => {
	if(payload === 'Alla aktiviteter') {
		state.filters.forEach(filter => {
			if(filter.name === 'Alla aktiviteter') filter.current = true
			else filter.current = false
		})
	} else {
		state.filters.forEach(filter => {
			if(filter.name === 'Alla aktiviteter'){ 
				filter.current = false
			} else if (filter.name === payload) {
				filter.current = !filter.current
			}
		});
		const hasCurrentObject = state.filters.some(obj => obj.current === true)
		if(!hasCurrentObject) {
			state.filters[0].current = true
		}
	}
  };

const clearFilterMutation: MutationHandler<string> = (state, { payload }) => {
	state.filters.forEach(filter => {
		filter.current = false
	});
	state.date = { start: undefined, end: undefined }
  };

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setResult: setResultMutation,
	setQuery: setQueryMutation,
	setFilter: setFilterMutation,
	setFilterModal: setFilterModalMutation,
	addResult: addResultMutation,
	updateFilterCount: updateFilterCountMutation,
	setRangeFilter: setRangeFilterModalMutation,
	clearFilter: clearFilterMutation,
	removeFilterModal: removeFilterModalMutation
}

export default mutations